import { useTranslation } from 'react-i18next'
import React from 'react'

import { useChecklistForm, useIsEditing } from './_form/ChecklistFormHandler'
import { useFieldsStepDef } from './fieldsStep/FieldsStep'
import { useQuestionsStepDef } from './questionsStep/QuestionsStep'
import { useSaveChecklist } from './_requests/saveChecklist'
import Steps from '../../../components/steps/Steps'

const EditChecklistForm = () => {
  const { t } = useTranslation('editChecklist')
  const form = useChecklistForm()
  const isEditing = useIsEditing()

  const fieldsStep = useFieldsStepDef()
  const questionsStep = useQuestionsStepDef()

  const steps = [
    fieldsStep, //
    questionsStep
  ]

  const [onSubmit, { loading, error }] = useSaveChecklist()

  return (
    <Steps
      t={t}
      isEditing={isEditing}
      steps={steps}
      onSubmit={onSubmit}
      loading={loading}
      errorMessage={error?.message}
    />
  )
}

export default EditChecklistForm
